import React from 'react';
import styled from 'styled-components';
import { SliceImageTextQuadrantItem } from '@contracts';
import Colors from './Colors';
import { MEDIA } from '@constants';
import { TextVariant, Typography } from '@components/shared/design/Typography';

const ImageTextQuadrantItem: React.FC<{ item: SliceImageTextQuadrantItem }> = ({ item }) => {
  if (!item?.item_title?.text) return null;

  return (
    <QuadrantItem>
      <ItemTitle $backgroundColor={item.item_title_background_color}>
        {item.item_title_icon?.url && <ItemIcon src={item.item_title_icon.url} alt={item.item_title_icon.alt || ''} />}
        <Typography $variant={TextVariant.BodyBoldLG}>{item.item_title.text}</Typography>
      </ItemTitle>
      <Typography $variant={TextVariant.BodyRegularLG} $mobileVariant={TextVariant.BodyRegularMD}>
        {item.item_description?.text}
      </Typography>
    </QuadrantItem>
  );
};

export default ImageTextQuadrantItem;

const QuadrantItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 12px;
  max-width: 300px;
  text-align: left;

  ${MEDIA.laptop} {
    gap: 5px;
    padding: 0;
    max-width: none;
  }
`;

const ItemIcon = styled.img`
  width: 24px;
  height: 24px;
`;

interface ItemTitleProps {
  $backgroundColor?: string;
}

const ItemTitle = styled.div<ItemTitleProps>`
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-radius: 100px;
  align-items: center;
  background: ${(props) => (props.$backgroundColor ? props.$backgroundColor : Colors.cream)};
  padding: 4px 8px;
  width: fit-content;

  ${MEDIA.tablet} {
    gap: 5px;
  }
`;
